import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Playlists Latest
 */
const playlistsLatest = buildAsyncStatReducer({
    key: Metrics.PLAYLISTS_LATEST,
    types: {
        request: Types.DASHBOARD_PLAYLISTS_LATEST.request,
        success: Types.DASHBOARD_PLAYLISTS_LATEST.success,
        failure: Types.DASHBOARD_PLAYLISTS_LATEST.failure,
    },
    transform: (state, { payload }) => {
        const { id, name } = payload[0] || {}
        return { id, name }
    },
})

/**
 * Playlists scheduled
 */
const playlistsScheduledNext = buildAsyncStatReducer({
    key: Metrics.PLAYLISTS_SCHEDULED_NEXT,
    types: {
        request: Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.request,
        success: Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.success,
        failure: Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.failure,
    },
    transform: (state, { payload }) => {
        const { id, name } = payload[0] || {}
        return { id, name }
    },
})

const playlistsReducers = [playlistsLatest, playlistsScheduledNext]

export default playlistsReducers
